<template lang="html">
    <section class="hero is-light is-bold is-fullheight">
        <div class="hero-body">
            <div class="has-text-centered container">
                <div class="logo">
                    <figure class="image">
                        <img src="/img/logo.png" alt="Logo Lapi">
                    </figure>
                </div>
                <h1 class="title">
                    <i class="fa fa-frown-o"></i> Página no encontrada
                </h1>
                <h2 class="subtitle">
                    Lo sentimos la página que buscas no se encuentra, inteta de nuevo o ¿Deseas volver a <router-link :to="{name:'Home'}" v-if="$auth.check()">Inicio</router-link><a href="/" v-else>Inicio</a>?
                </h2>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        mounted() {
            this.$root.preloader = false;
        }
    }
</script>

<style scoped>
    .logo {
        max-width: 350px;
        margin: 0 auto;
    }
</style>
